<template>
  <div class="dictionaryDetail">
    <el-button v-show = "isType === 'edit'" icon="el-icon-plus" type="primary" style="float: right; margin-bottom: 20px" @click="addRow">增加一行</el-button>
    <el-table :data="tableData" ref="tbl" border max-height="600" style="width: 100%; margin-top: 50px;" tooltip-effect="dark" :key="componentKey">
      <el-table-column type="index" label="序号" width="180" fixed></el-table-column>
      <el-table-column prop="dictInfoName" label="字典表名称" fixed show-overflow-tooltip></el-table-column>
      <el-table-column prop="optionName" label="字典表选项" fixed show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div @dblclick="toggleEdit(row)">
<!--            双击后-->
            <el-input v-if="row.edit && isType === 'edit'" v-model="row.optionName" @input="updateOptionName(row)"></el-input>
<!--            未双击-->
            <div v-else>{{ row.optionName === '-' ? '' : row.optionName }}<span v-if="isType === 'edit' && row.optionName === '-'">{{'双击 编辑选项名称'}}</span></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch size="mini" v-model="scope.row.status" active-text="启用" @change="res => switchStatus(1, res, scope.row)" :disabled="isType === 'detail'"></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <div class="tools" v-show = "isType === 'edit' && isShowConfirmButton">
      <el-button type="primary" @click="saveForm">保存</el-button>
      <el-button type="primary" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
  import DATADICTIONARYAPI from '@/api/dataDictionary';

  export default {
    props: {
      dictInfoId: {
        type: [String, Number]
      },
      isType: {
        type: [String, Number]
      },
    },
    components: {},
    data() {
      return {
        tableData: [],
        componentKey: 0,

        isShowConfirmButton: false,

        currOptionId: -1,
        currOptionName: '',
        currOriginOptionName: '',           // 双击后，修改前的值，用于比较是否更改

        originalOptionNames: []             // 修改前的选项列表
      };
    },
    computed: {},
    methods: {
      // 新增一行
      addRow() {
        const findItem = this.tableData.find(item => item.optionName === '-');
        if (!findItem) {
          const params = {
            dictInfoId: this.dictInfoId,
            optionName: '-'
          };
          DATADICTIONARYAPI.addDictOption(params).then(res => {
            if (res.data.code === 200) {
              this.$message.success('操作成功');
              this.searchDictOptionListByDictInfoId();
            }
          });

          this.isShowConfirmButton = true;
        } else {
          this.$message.warning('存在未编辑选项，请直接编辑！');
        }
      },

      // 双击单元格
      toggleEdit(row) {
        row.edit = true;
        this.currOptionId = row.id;
        this.currOptionName = row.optionName;
        this.currOriginOptionName = row.optionName;
        // 双击后，仅该行可编辑，其他行切换为不可编辑
        this.tableData.forEach(item => {
          if (item.id !== this.currOptionId) {
            item.edit = false;
          }
        });
        this.componentKey += 1;
        this.isShowConfirmButton = true;

        this.originalOptionNames = this.tableData.map(item => item.optionName);      // 该参数用于与后面修改参数比较是否重名
      },

      updateOptionName(row) {
        this.currOptionName = row.optionName;
      },

      saveForm() {
        const params = {
          id: this.currOptionId,
          optionName: this.currOptionName,
        };

        if (this.currOptionName === '') {
          this.$message.warning('选项名称不能为空！');
        } else {
          // 验证修改的选项是否已存在，不能重名，未修改和 '-' 则可以正常保存
          let isFind = false;
          if ( this.originalOptionNames.includes(this.currOptionName) &&
            this.currOriginOptionName !== this.currOptionName) {
            isFind = true;
          }
          if (!isFind) {
            DATADICTIONARYAPI.updateDictOption(params).then(res => {
              if (res.data.code === 200) {
                this.$message.success('操作成功');
                this.tableData = this.tableData.map(item => {
                  item.edit = false;
                  return item;
                });
                this.searchDictOptionListByDictInfoId();
                this.isShowConfirmButton = false;
                this.currOptionId = '';
                this.currOptionName = '';
              }
            });
          } else {
            this.$message.warning('选项名称 "'+ this.currOptionName +'" 已存在！');
          }
        }
      },

      cancel() {
        this.tableData = this.tableData.map(item => {
          item.edit = false;
          return item;
        });
        this.searchDictOptionListByDictInfoId();
        this.isShowConfirmButton = false;
      },

      switchStatus(index, res, row) {
        const params = {
          id: row.id,
        };
        params.status = res ? 0 : 1;        // 0-启用，1-禁用
        DATADICTIONARYAPI.enableOrDisableDictOption(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功');
            this.searchDictOptionListByDictInfoId();
          }
        });
      },

      // 查询字字典表详情
      searchDictOptionListByDictInfoId() {
        let params = {
          dictInfoId: this.dictInfoId
        };
        let self = this;
        DATADICTIONARYAPI.searchDictOptionListByDictInfoId(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.tableData = res.data.data.map(obj => {
              obj.status = obj.status === 0;
              return obj;
            });
            this.tableData = this.tableData.map(item => {
              item.edit = false;
              return item;
            });
            this.$nextTick(function () {
              self.$refs.tbl.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },
    },

    created() {
      // 获取字典表列表
      this.searchDictOptionListByDictInfoId();
    }
  };
</script>

<style lang="scss" scoped>
  .dictionaryDetail {
    .tools {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/dataDictionary/dictionaryDetail.vue